"use strict";

import React from 'react';
import WistiaInlineEmbed from "../../component/WistiaInlineEmbed";

const ProductGallerySlideVideo = ({slide={}, videoProps={},}) => {
    return (
        <div>
            <WistiaInlineEmbed videoId={slide.name} />
        </div>
    );
};

export default ProductGallerySlideVideo;
